// Chakra imports
import { Button, Flex, Input, Spinner, useColorModeValue } from "@chakra-ui/react";
// Assets
import React from "react";
import { useDropzone } from "react-dropzone";

import { motion } from 'framer-motion';
function Dropzone(props) {
  const { content, onDrop, accept, multiple = true, isUploading = false, ...rest } = props;
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop, accept, multiple });
  const bg = useColorModeValue("gray.100", "navy.700");
  const borderColor = useColorModeValue("secondaryGray.100", "whiteAlpha.100");
  return (
    <motion.div
      style={{ width: '100%' }}
      initial={{ scale: 1 }}
      animate={{ scale: isDragActive ? 1.03 : 1, borderColor: isDragActive ? '#805AD5' : borderColor }}
      transition={{ duration: 0.2 }}
      {...getRootProps({ className: 'dropzone' })}
    >
      <Flex
        align='center'
        justify='center'
        bg={bg}
        border='1px dashed'
        borderColor='inherit'
        borderRadius='16px'
        w='100%'
        h='max-content'
        minH='100%'
        position='relative'
        cursor='pointer'
        {...rest}
      >
        <Input variant='main' {...getInputProps()} />
        {content}
        {isUploading && (
          <Flex position='absolute' top='0' left='0' right='0' bottom='0' bg='blackAlpha.400' align='center' justify='center' borderRadius='16px'>
            <Spinner size='lg' color='white' />
          </Flex>
        )}
      </Flex>
    </motion.div>
  );
}

export default Dropzone;
